// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ku-0";
export var assigneeDetails = "_ku-1";
export var assigneeInfo = "_ku-2";
export var dropdownContainer = "_ku-4";
export var dropdownImage = "_ku-5";
export var editAssigneeInfo = "_ku-3";
export var editAssigneeModalContainer = "_ku-6";
export var hidden = "_ku-8";
export var input = "_ku-7";